import { Injectable } from '@angular/core';

// Common Libs
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';

// Model
import { DisableFeatures } from '../models/disableFeatures';

@Injectable()
export class DisableFeatureService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

  getDisableFeatures(event_id){
    if(this.utilityService.isLogged()){
      let data: AngularFireObject<DisableFeatures> = this.db.object(`${Constants.EVENT_URL}/${event_id}/${Constants.PREDERENCES_URL}/${Constants.PREF_DISABLE_FEATURES}`)
      return data.valueChanges();
    }
    return null;
  }

  updateDisableFeatures(event_id, disableFeatures: DisableFeatures){
    console.log("Saving Disable Features");
    return this.db.object(`${Constants.EVENT_URL}/${event_id}/${Constants.PREDERENCES_URL}/${Constants.PREF_DISABLE_FEATURES}`).set(Object.assign({},disableFeatures))
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/disable-feature.service.ts